export default __webpack_public_path__ + "static/media/Iphone2.f15b23f9.jpg";